import React, {Component} from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {toast} from 'react-toastify';
import _ from 'lodash';

import ErrorMsg from "../common/ErrorMsg";
import FormValidator from "../../validations/FormValidator";
import {ValidationRules} from "./ValidationRules";


export default class ChangePasswordModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            passwordDetail: {
                password: '',
                new_password: '',
                confirm_password: ''
            },
            errors: {},
        };
        this.validator = new FormValidator(ValidationRules);
    }

    toggleModal = () => {
        let passwordDetail = {
            password: '',
            new_password: ''
        }
        this.setState({passwordDetail, errors: {}}, () => this.props.toggleModal());
    };

    handleChange = (e) => {
        let name = e.currentTarget.name;
        let value = e.currentTarget.value;
        let passwordDetail = {...this.state.passwordDetail};
        passwordDetail[name] = value;
        this.setState({passwordDetail});
    };

    setPassword = async (e) => {
        e.preventDefault();
        const {passwordDetail} = this.state;
        let validationStatus = this.validator.validateForm(passwordDetail);
        if (!validationStatus.isValid) {
            this.setState((prevState) => ({
                errors: validationStatus.errors,
            }));
        } else if (passwordDetail.new_password !== passwordDetail.confirm_password) {
            let errors = {...this.state.errors};
            errors['confirm_password'] = 'New and Confirm Password Does not match.';
            this.setState((prevState) => ({errors: errors}));
        } else {
            try {
                let result = await this.props.setPassword(this.state.passwordDetail);
                if (result) {
                    toast.success("Password changed successfully.");
                    this.toggleModal();
                }
            } catch(error) {
                console.log(error);
                toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
            }
        }
    };

    render() {
        const {passwordDetail, errors} = this.state;
        
        return (
            <Modal isOpen={this.props.modal} toggle={this.toggleModal}>
                <ModalHeader toggle={this.toggleModal}>
                    Change Password
                </ModalHeader>
                <form>
                <ModalBody>
                    <div className="row">
                        <div className="col-sm-4 text-sm-right pt-2">
                            <label>Current Password: </label>
                        </div>
                        <div className="col-sm-8 mb-3">
                            <input type="password" className="form-control" name="password" value={passwordDetail.password} onChange={this.handleChange} />
                            {errors.password ? <span className="span-error"> {errors.password}</span> : ''}
                        </div>
                        <div className="col-sm-4 text-sm-right pt-2">
                            <label>New Password: </label>
                        </div>
                        <div className="col-sm-8 mb-3">
                            <input type="password" className="form-control" name="new_password" value={passwordDetail.new_password} onChange={this.handleChange} />
                            {errors.new_password ? <span className="span-error"> {errors.new_password}</span> : ''}
                        </div>
                        <div className="col-sm-4 text-sm-right pt-2">
                            <label>Confirm Password: </label>
                        </div>
                        <div className="col-sm-8 mb-2">
                            <input type="password" className="form-control" name="confirm_password" value={passwordDetail.confirm_password}  onChange={this.handleChange} />
                            {errors.confirm_password ? <span className="span-error"> {errors.confirm_password}</span> : ''}
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button type="submit" className='btn btn-success' onClick={this.setPassword}>Submit</Button>
                    <Button className='btn btn-secondary' onClick={this.toggleModal}>Close</Button>
                </ModalFooter>
                </form>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/staffDashboard/ChangePasswordModal.js